module.exports = __webpack_public_path__ + "static/media/valor4.2d8bae8c.png";